import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";

import PermissionService from "src/services/User Management/Permission";

const service = new PermissionService();

const REDUCER_MODULE_NAME = "PERMISSION";

const initialState = {
  data: {},
  loading: false,
  error: "",
};

export const findAll = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/findAll`,
  async () => {
    const { data } = await service.findAll();
    return data;
  },
);

export const permissionSlice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    clean: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(findAll.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addMatcher(isAnyOf(findAll.pending), (state) => {
        state.loading = true;
        state.error = "";
      })
      .addMatcher(isAnyOf(findAll.fulfilled), (state) => {
        state.loading = false;
      })
      .addMatcher(isAnyOf(findAll.rejected), (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al cargar permisos";
      });
  },
});

export const { clean } = permissionSlice.actions;

export default permissionSlice.reducer;
